import { render, staticRenderFns } from "./attach-upload.vue?vue&type=template&id=51f751e4&"
import script from "./attach-upload.vue?vue&type=script&lang=js&"
export * from "./attach-upload.vue?vue&type=script&lang=js&"
import style0 from "./attach-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports